import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	clearWorkVendorFilters,
	updateWorkVendorFilters,
} from '../../actions/work_analytics_actions';
import { fetchWorkOrderCountByVendor } from '../../thunks/work_analytics_thunks';
import WorkAnalyticsCategoryBreakdownPage from '../work_analytics_category_breakdown_page/WorkAnalyticsCategoryBreakdownPage';
import { WORK_ANALYTICS_FIELD_DISPLAY_NAME } from '../../utils/DataFormatterUtils';

class WorkAnalyticsOverviewVendorsPage extends React.Component<any, any> {
	render() {
		const { analytics, userType } = this.props;
		const { workOrderCountByVendor, vendorFilters } = analytics;

		return [
			<WorkAnalyticsCategoryBreakdownPage
				updateFilters={updateWorkVendorFilters}
				clearFilters={clearWorkVendorFilters}
				workOrderCountByCategory={workOrderCountByVendor}
				filters={vendorFilters}
				fetchWorkOrderCountsByCategory={fetchWorkOrderCountByVendor(userType)}
				fieldDisplayName={WORK_ANALYTICS_FIELD_DISPLAY_NAME.supplier}
				comparisonApiSubstring="work_order_counts_by_supplier_facility"
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	accountActivated: state.session.accountActivated,
	currentUser: state.session.currentUser,
	analytics: state.work_analytics,
});

const mapDispatchToProps = (dispatch) => ({});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(WorkAnalyticsOverviewVendorsPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
